import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  sortBy: "",
  sortOrder: "",
  search: "",
  clearSelection: false,
  showBulkUpload: false,
};

const shopCertificateSlice = createSlice({
  name: "shopCertificate",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = shopCertificateSlice.actions;
export default shopCertificateSlice.reducer;
